/**
 * Classe que representa o field de escolha de cor.
 * @author: Kete
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.ColorPicker = (function () {

    function ColorPicker (options) {

        Monet.UI.Fields.TextField.apply(this, arguments);

        const green = '#4aba71',
          red = '#ee3c25',
          yellow = '#fff200',
          blue = '#00aeff',
          orange = '#ff7238',
          ligthGreen = '#b0d25a',
          ligthBlue = '#5ad1d2',
          gray = '#c1bfbf';

        this.defaultColors = [
          [gray, yellow, ligthBlue, ligthGreen ],
          [blue, green, orange, red ]
        ];

        this.colorPicker = null;
        this.showPaletteOnly = false;

        if(options && options.colorpicker ){
            if(options.colorpicker.change){
                this._change = options.colorpicker.change || function () {};
            }

            if(options.colorpicker.color){
                this._color = options.colorpicker.color;
            }
        }

        this.getColorPicker = function (){
            return this.colorPicker;
        };

        this.setTextLabel = function (label) {
            if (this.meta && this.meta.showLabel) {
                this.createLabel();
                this.rootEl.appendChild(this.label);
                this.label.textContent = label;
            }
        };

        this.createBaseStructure = function(){
            this.createRootElement();
        };

        this.createElement = function () {
            this.input = document.createElement('input');
            this.input.class = 'colorpickervalue';
            this.rootEl.className = 'colorpicker';
            this.rootEl.appendChild(this.input);

            const { palette, showPaletteOnly, showSelectionPalette } = this.meta || {};

            $(this.rootEl.firstChild).spectrum({
                color: this._color || this.defaultValue,
                showAlpha: false,
                showSelectionPalette: (typeof showSelectionPalette !== undefined) ? showSelectionPalette : true,
                chooseText: Monet.I18n.getResourcesByKey('general.button.ok'),
                cancelText: Monet.I18n.getResourcesByKey('general.button.cancel'),
                showPalette: true,
                showPaletteOnly: showPaletteOnly || this.showPaletteOnly,
                palette: palette || this.defaultColors,
                preferredFormat: "rgb",
                change: this._change
            });

            this.colorPicker = $(this.rootEl.firstChild);
            if (!palette) {
                $(this.rootEl.firstChild).spectrum('set', blue);
            }
        };

        this.getValue = function () {
            return this.input.value;
        };

        this.setValue = function (value) {
          if (value) {
            this._color = value;
            $(this.rootEl.firstChild).spectrum('set', this._color);
          }
        };

        this.clear = function (){
            this.setColor(this.defaultValue);
        };

        this.setColor = function (color){

            this._color = color || this.defaultValue;
            $(this.rootEl.firstChild).spectrum('set', this._color);
        };

        this.render = function () {
            this.createElement();
            this.setValue(this._color || this.defaultValue);
            return this.rootEl;

        };

        this.createBaseStructure();

    }

    return ColorPicker;

}());